import {ChangeDetectionStrategy, Component} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";


@Component({
    selector: "section-inbound-detailed-allocations-list",
    template: `
        <h1 class="container-heading">Allocations in transit detailed</h1>
        <mat-card>
            <mat-card-content>
                <section-allocations-list type="inbound" [state]="state"></section-allocations-list>
            </mat-card-content>
        </mat-card>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InboundDetailedAllocationsListComponent implements Base.IComponent {

    public readonly state: Base.IState;

    public constructor() {
    }


    public ngConfig(): Base.IConfig {
        return {
            name: "allocations-in-transit-detailed",
            actions: {
                "browse": ["browse_inventory_allocations"]
            }
        };
    }
}
